import React from "react";
import { CustomSelect } from "../Shared/SearchableSelect";

// Parent stores are filtered and searched by the API, not the first loaded page
export const PARENT_STORE_QUERY = { "filter[is_parent_store]": 1 };

const ParentStoreSelect = (props) => (
  <CustomSelect
    source="store_id"
    resource="stores"
    optionValue="id"
    optionLabel="store_name"
    query={PARENT_STORE_QUERY}
    searchParam="filter[store_name]"
    pageSize={100}
    {...props}
  />
);

export default ParentStoreSelect;
